const RECORD_TASK_TYPE = {
    // 第一次上傳到雲端
    UPLOAD_TO_CLOUD: "uploadToCloud",
    // 更新存檔到雲端
    UPDATE_TO_CLOUD: "updateToCloud",
    // 刪除雲端存檔
    DELETE_CLOUD: "deleteCloud",
    // 從雲端存檔下載
    DOWNLOAD_FROM_CLOUD: "downloadFromCloud",
    // 從雲端存檔更新本地資料
    UPDATE_FROM_CLOUD: "updateFromCloud",
    // 刪除本地存檔
    DELETE_LOCAL: "deleteLocal"
}

export { RECORD_TASK_TYPE };